import "./_common";
import { GlobalComponents, GlobalStores } from "../react_isomorphic/global";
import { SimilarBooksAuthorsComponents, SimilarBooksAuthorsStores } from "../react_isomorphic/similar_books_authors";
import { HeaderComponents, HeaderStores } from "../react_isomorphic/site_header";

window.ReactComponents = Object.assign(
  {},
  GlobalComponents,
  HeaderComponents,
  SimilarBooksAuthorsComponents
);

window.ReactStores = Object.assign(
  {},
  GlobalStores,
  HeaderStores,
  SimilarBooksAuthorsStores
);
